import { Form, Input, Row, Column } from '@bancobarigui/barihaus';

export function InspectionForm() {
  return (
    <Row gutter={[24, 16]}>
      <Column span={12}>
        <Form.Item label="Canal" name="channel" initialValue="web">
          <Input disabled value="Web" />
        </Form.Item>
      </Column>

      <Column span={12}>
        <Form.Item label="Nº de Proposta" name="proposalNumber"  rules={[{ required: true, message: 'Informe o número da proposta.' }]} >
          <Input placeholder="" maxLength={100} />
        </Form.Item>
      </Column>
    </Row>
  );
}
